import { Outlet, createFileRoute } from '@tanstack/react-router';

function RouteComponent() {
  return (
    <div className='flex flex-col max-h-sidebar-h overflow-y-auto w-full gap-6 p-5 mb:p-10'>
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/_app/_dashboard/projetos')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: 'Meus Projetos',
    };
  },
});
